import { render, staticRenderFns } from "./FormClient.vue?vue&type=template&id=a25534e0"
import script from "./FormClient.vue?vue&type=script&lang=js"
export * from "./FormClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports